// Front/src/pages/AccuracyTable.js

import { React, useMemo } from "react";
import PropTypes from 'prop-types';

export const rowData = [
    {
      I: "0",
      II: "0",
      III: "0",
      IV: "0",
      multiplier: { Marketing: 0.5, Service: 1 },
      id: 1,
    },
    {
      I: "Minimum",
      II: "Minimum",
      III: "Minimum",
      IV: "Minimum",
      multiplier: { Marketing: 0.5, Service: 1 },
      id: 2,
    },
    {
      I: "0 ≤ m ≤ 50,000",
      II: "0 ≤ m ≤ 5,000",
      III: "0 ≤ m ≤ 500",
      IV: "0 ≤ m ≤ 50",
      multiplier: { Marketing: 0.5, Service: 1 },
      id: 3,
    },
    {
      I: "50,000 < m ≤ 200,000",
      II: "5,000 < m ≤ 20,000",
      III: "500 < m ≤ 2,000",
      IV: "50 < m ≤ 200",
      multiplier: { Marketing: 1, Service: 2 },
      id: 4,
    },
    {
      I: "200,000 < m",
      II: "20,000 < m ≤ 100,000",
      III: "2,000 < m ≤ 10,000",
      IV: "200 < m ≤ 1,000",
      multiplier: { Marketing: 1.5, Service: 3 },
      id: 5,
    },
    {
      I: "MAX",
      II: "MAX",
      III: "MAX",
      IV: "MAX",
      multiplier: { Marketing: 1.5, Service: 3 },
      id: 6,
    },
  ];

  const AccuracyClassTable = ({ accuracyClass, reportType, eValue }) => {
    const classKey = useMemo(() => ["I", "II", "III", "IV"][accuracyClass - 1], [accuracyClass]);
  
    if (!classKey || !reportType || !eValue || isNaN(Number(eValue))) return null;
  
    const e = parseFloat(eValue);
    const getDeviation = (multiplier) => `Allowed deviation: ±${(e * multiplier).toFixed(5)}`;
  
    return (
      <div className="accuracy-class-table" style={{ overflowX: 'auto', marginTop: '10px' }}>
        <table border="1" cellPadding="8" cellSpacing="0" style={{ borderCollapse: "collapse", width: "100%", textAlign: "center" }}>
          <thead>
            <tr>
              <th>Class {classKey}</th>
              <th>{reportType}</th>
              <th>#</th>
            </tr>
          </thead>
          <tbody>
            {rowData.map(row => (
              <tr key={row.id}>
                <td dir="ltr" style={{ direction: 'ltr' }}>{row[classKey]}</td>
                <td>{getDeviation(row.multiplier[reportType])}</td>
                <td>{row.id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  
  AccuracyClassTable.propTypes = {
    accuracyClass: PropTypes.number.isRequired,
    reportType: PropTypes.oneOf(['Marketing', 'Service']).isRequired,
    eValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  };
  
  export default AccuracyClassTable;
  
